/**
 * WorkflowSectionV2 — the "creative studio in one prompt" agent pipeline.
 *
 * A flat, non-interactive image of the agent graph (Director → Character →
 * Location → Animator on the metallic background). Replaced the draggable
 * ReactFlow graph entirely — nothing to grab, nothing to scroll-trap, and no
 * ReactFlow dependency on the landing page.
 */
import { useTranslation } from 'react-i18next'

export default function WorkflowSectionV2() {
  const { t } = useTranslation('landing')
  return (
    <section className="bg-black px-4 pb-[60px] pt-20 sm:px-6 md:px-20 md:pt-[140px]">
      <div className="mx-auto flex max-w-[1280px] flex-col gap-10 md:gap-[60px]">
        {/* Header */}
        <div className="flex flex-col gap-4">
          <h2 className="max-w-[640px] font-[Fustat] text-hero font-medium leading-[1.1] text-white md:text-display-md">
            {t('workflowV2.heading')}
          </h2>
          <p className="max-w-[784px] font-[Fustat] text-base leading-[1.6] text-[#a1a1aa] md:text-xl md:font-medium">
            {t('workflowV2.subtitle')}
          </p>
        </div>

        {/* Agent pipeline — static image */}
        <div className="w-full overflow-hidden rounded-[28px] border border-white/[0.08] md:rounded-[32px]">
          <img
            src="/landing-v2/workflow-graph.jpg?v=2"
            alt={t('workflowV2.imageAlt')}
            className="block h-auto w-full select-none pointer-events-none"
          />
        </div>
      </div>
    </section>
  )
}
